import Vue from 'vue'
import debounce from 'lodash.debounce'
Vue.directive('square', {
  inserted (el) {
    /* eslint-disable */
    $(el).height(($(el).width() * 2) / 75 + 'rem')
  }
})

Vue.directive('viewFixed', {
  update (el) {
    if ($(el).css('display') === 'none') {
      $('.c-content').css({overflow: 'auto'})
    } else {
      $('.c-content').css({overflow: 'hidden'})
    }
  }
})

Vue.directive('scrollLoad', {
  bind (el, binding, vnode) {
    el['scrollLoadCTX'] = {
      vm: vnode.context,
      scrollListener: scrollListener
    }
    let scrollListener = debounce(function () {
      let offset = $(el).offset()
      let top = offset.top
      let height = offset.height
      let windowHeight = $(window).height()
      let nowHeight = Math.floor(height + top)
      if (nowHeight < windowHeight + 50) {
        vnode.context.$emit('scrollLoadEvent', 'sc')
      }
    }, 100)
    el.addEventListener('scroll', scrollListener)
    el.addEventListener('touchmove', scrollListener)

  },
  unbind (el) {
    el.removeEventListener('scroll', el['scrollLoadCTX'].scrollListener)
    el.removeEventListener('touchmove', el['scrollLoadCTX'].scrollListener)
    console.log('unbind')
  }
})



// WEBPACK FOOTER //
// ./src/directive/index.js